import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'

import LoadingReducer from './LoadingReducer';



import LangReducer from "./LangReducer";

const rootReducer = combineReducers({
  form: formReducer,

  lang: LangReducer,

  loading: LoadingReducer,



});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/Reducers/index.js